import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=58687554&scoped=true"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"
import style0 from "./recovery.vue?vue&type=style&index=0&id=58687554&prod&scoped=true&lang=css"
import style1 from "./recovery.vue?vue&type=style&index=1&id=58687554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58687554",
  null
  
)

export default component.exports